export default "__VITE_ASSET__b87a94f1__"